import { FunctionComponent, useEffect, useState } from "react";
import styles from "../../pages/CheckoutData/CheckoutDados.module.css";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useCheckout } from "../../context/CheckoutContext";

const BackButton: FunctionComponent = ({path}: { path:string }) => {
  const navigate = useNavigate()
  const params = useParams();
  const [searchParams] = useSearchParams();
  const couponURL = searchParams.get('cupom');

  return (
    <div className={styles.buttons} onClick={() => params.slug 
    ? navigate(path === "/" ? `/${params.slug}${couponURL 
      ? `?cupom=${couponURL}` : ''}`
      : path + `/${params.slug}${couponURL ? `?cupom=${couponURL}` : ''}`) 
    : navigate(`${path}${couponURL ? `?cupom=${couponURL}` : ''}`) }>
      <img className={styles.icones} alt="" src="/icones.svg" />
      <div className={styles.continuarACompra}>Voltar</div>
      <img className={styles.icones1} alt="" src="/icones1.svg" />
    </div>
  );
};

export default BackButton;
